(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yg-blog-post"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
  class YGBlogPosts extends HTMLElement {
    constructor() {
      super();
      this.swiperInstance = null;
    }

    connectedCallback() {
      this.initSwiper();
      this.initTimelineInteraction();
    }

    disconnectedCallback() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
    }

    initSwiper() {
      this.swiperInstance = new Swiper(this, {
        spaceBetween: 16, 
        slidesPerView: 1.2,
        navigation: {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev'),
        },
        breakpoints: { 
          768: { 
            spaceBetween: 16, 
            slidesPerView: 3, 
          }, 
        }
      });

    }

  }

  if (!customElements.get('yg-blog-posts')) {
    customElements.define('yg-blog-posts', YGBlogPosts);
  }
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-card-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // 基础轮播类
    class YGCarouselBase extends HTMLElement {
      constructor() {
        super();
        this.wrapper = null;
        this.slides = [];
        this.animationName = '';
      }

      initCarousel() {
        this.wrapper = this.querySelector('.swiper-wrapper');
        this.slides = Array.from(this.querySelectorAll('.swiper-slide'));
        
        if (this.slides.length === 0) {
          this.style.display = 'none';
          return;
        }
        
        this.cloneSlides();
        this.waitForImagesAndSetup();
        this.setupHoverEvents();
      }

      cloneSlides() {
        const cloneCount = 5;
        for (let i = 0; i < cloneCount; i++) {
          this.slides.forEach(slide => {
            const clone = slide.cloneNode(true);
            this.wrapper.appendChild(clone);
          });
        }
      }

      getGap() {
        return window.innerWidth > 767 ? 20 : 12;
      }

      setupAnimation() {
        let singleGroupWidth = 0;
        this.slides.forEach(slide => {
          singleGroupWidth += slide.offsetWidth;
        });
        
        const gap = this.getGap();
        singleGroupWidth += gap * this.slides.length;
        
        const duration = singleGroupWidth / 30;
        
        this.wrapper.style.animation = 'none';
        this.wrapper.offsetHeight;
        
        this.wrapper.style.transform = 'translateX(-33.33%)';
        this.wrapper.style.animation = `${this.animationName} ${duration}s linear infinite`;
      }

      waitForImagesAndSetup() {
        const images = this.wrapper.querySelectorAll('img');
        
        if (images.length === 0) {
          setTimeout(() => this.setupAnimation(), 100);
          return;
        }

        let loadedCount = 0;
        const checkAllLoaded = () => {
          loadedCount++;
          if (loadedCount === images.length) {
            setTimeout(() => this.setupAnimation(), 100);
          }
        };

        images.forEach(img => {
          if (img.complete) {
            checkAllLoaded();
          } else {
            img.addEventListener('load', checkAllLoaded);
          }
        });
      }

      setupHoverEvents() {
        this.addEventListener('mouseenter', () => {
          this.wrapper.style.animationPlayState = 'paused';
        });

        this.addEventListener('mouseleave', () => {
          this.wrapper.style.animationPlayState = 'running';
        });
      }

      handleResize() {
        this.setupAnimation();
      }
    }

    class YGCarouselTop extends YGCarouselBase {
      constructor() {
        super();
        this.animationName = 'slideRight';
        this.initCarousel();
      }
    }

    class YGCarouselBottom extends YGCarouselBase {
      constructor() {
        super();
        this.animationName = 'slideLeft';
        this.initCarousel();
      }
    }

    if (!customElements.get('yg-carousel-top')) {
      customElements.define('yg-carousel-top', YGCarouselTop);
    }

    if (!customElements.get('yg-carousel-bottom')) {
      customElements.define('yg-carousel-bottom', YGCarouselBottom);
    }

    // 响应式处理
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        document.querySelectorAll('yg-carousel-top, yg-carousel-bottom').forEach(carousel => {
          if (carousel.handleResize) {
            carousel.handleResize();
          }
        });
      }, 250);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-in-the-box"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperInTheBox extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        if (this.swiper) return;
        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-in-the-box')) {
      customElements.define('yg-swiper-in-the-box', YGSwiperInTheBox);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-box-switcher"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column-switcher"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-product-multi-column-switcher"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-tab-blog-post"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGTabBlogSwiper extends HTMLElement {
      constructor() {
        super();
        this.swiperInstance = null;
      }

      connectedCallback() {
        this.initSwiper();
      }

      disconnectedCallback() {
        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
          this.swiperInstance = null;
        }
      }

      initSwiper() {
        this.swiperInstance = new Swiper(this, {
          spaceBetween: 16,
          slidesPerView: 1.2,
          observer: true,
          observeParents: true,
          resizeObserver: true,
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          breakpoints: {
            768: {
              spaceBetween: 16,
              slidesPerView: 3,
            },
          },
        });
      }

      updateSwiper() {
        if (this.swiperInstance) {
          this.swiperInstance.updateSize();
          this.swiperInstance.updateSlides();
          this.swiperInstance.updateProgress();
          this.swiperInstance.updateSlidesClasses();
          this.swiperInstance.update();
        }
      }
    }

    if (!customElements.get('yg-tab-blog-swiper')) {
      customElements.define('yg-tab-blog-swiper', YGTabBlogSwiper);
    }

    class YGTabBlogPostSection extends HTMLElement {
      connectedCallback() {
        this.tabs = this.querySelectorAll('.yg-tab-blog-post__tab');
        this.panels = this.querySelectorAll('.yg-tab-blog-post__panel');

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.switchTab(tab.dataset.tabId));
        });
      }

      switchTab(tabId) {
        this.tabs.forEach((tab) => {
          tab.classList.toggle('active', tab.dataset.tabId === tabId);
        });

        this.panels.forEach((panel) => {
          const isActive = panel.dataset.tabId === tabId;
          panel.classList.toggle('active', isActive);
          if (isActive) {
            panel.querySelectorAll('yg-tab-blog-swiper').forEach((el) => {
              el.updateSwiper();
              requestAnimationFrame(() => {
                el.updateSwiper();
              });
            });
          }
        });
      }
    }

    if (!customElements.get('yg-tab-blog-post-section')) {
      customElements.define('yg-tab-blog-post-section', YGTabBlogPostSection);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
